interface IndicatorProps {
  size?: number;
  colour: string;
  pulse?: boolean;
}

export default function Indicator({ size, colour, pulse }: IndicatorProps) {
  return (
    <span
      className={`flex absolute h-${size} w-${size} top-0 right-0 -mt-1 -mr-1`}
    >
      <span
        className={`${
          pulse && "animate-ping"
        } absolute inline-flex h-full w-full rounded-full bg-${colour} opacity-75`}
      ></span>
      <span
        className={`relative border border-white inline-flex rounded-full h-${size} w-${size} bg-${colour}`}
      ></span>
    </span>
  );
}

Indicator.defaultProps = {
  size: 3,
  pulse: false,
};
